import React, { useState, useEffect } from "react";
import { fetchLicenses, createLicense, updateLicense, deleteLicense } from "../../../../../services/experienceService";

const LicenseList = ({ profileId, initialLicenses }) => {
    const [licenses, setLicenses] = useState(initialLicenses || []);
    const [editingIndex, setEditingIndex] = useState(null);
    const [tempLicense, setTempLicense] = useState({ title: "", license_number: "", issue_date: "" });
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [mouseDownOutside, setMouseDownOutside] = useState(false);

    const openAddModal = () => {
        setTempLicense({ title: "", license_number: "", issue_date: "" });
        setEditingIndex(null);
        setShowModal(true);
    };

    const openEditModal = (index) => {
        setEditingIndex(index);
        setTempLicense({ ...licenses[index] });
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setEditingIndex(null);
    };

    const handleSave = async () => {
        try {
            setLoading(true);
            const payload = { ...tempLicense, profile: profileId };

            const newLicense = editingIndex === null
                ? await createLicense(payload)
                : await updateLicense(licenses[editingIndex].id, payload);

            if (editingIndex === null) {
                setLicenses((prev) => [newLicense, ...prev]);
            } else {
                const updated = [...licenses];
                updated[editingIndex] = newLicense;
                setLicenses(updated);
            }

            closeModal();
        } catch (err) {
            console.error(err);
            alert("Failed to save license.");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (index) => {
        const licenseId = licenses[index].id;
        if (!window.confirm("Are you sure you want to delete this license?")) return;

        try {
            await deleteLicense(licenseId);
            setLicenses((prev) => prev.filter((_, i) => i !== index));
        } catch (err) {
            console.error(err);
            alert("Failed to delete license.");
        }
    };

    return (
        <>
            <div className="experience-block">

                {/* Header Row */}
                <div className="experience-header-row">
                    <h3 className="experience-title">Licenses</h3>

                    <button className="add-certificate-top-btn" onClick={openAddModal}>
                        + Add
                    </button>
                </div>

                {/* Existing Licenses */}
                {licenses.map((license, index) => (
                    <div key={index} className="experience-license-card">
                        <div className="experience-license-icons">
                            <i
                                className="fa-solid fa-pen"
                                onClick={() => openEditModal(index)}
                            ></i>
                            <i
                                className="fa-solid fa-trash"
                                onClick={() => handleDelete(index)}
                            ></i>
                        </div>

                        <div className="license-field">
                            <span className="license-label">Title:</span> {license.title}
                        </div>
                        <div className="license-field">
                            <span className="license-label">Number:</span> {license.license_number}
                        </div>
                        <div className="license-field">
                            <span className="license-label">Issue Date:</span> {license.issue_date}
                        </div>
                    </div>

                ))}


            </div>
            {/* ------- MODAL ------- */}
            {showModal && (
                <div
                    className="experience-modal-backdrop"
                    onMouseDown={(e) => {
                        if (e.target.classList.contains("experience-modal-backdrop")) {
                            setMouseDownOutside(true); // mark that mousedown started on backdrop
                        } else {
                            setMouseDownOutside(false); // clicked inside modal
                        }
                    }}
                    onMouseUp={(e) => {
                        if (mouseDownOutside && e.target.classList.contains("experience-modal-backdrop")) {
                            closeModal(); // only close if both down & up on backdrop
                        }
                        setMouseDownOutside(false);
                    }}
                >
                    <div
                        className="experience-modal-content"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h3 className="freelancer-modal-title">
                            {editingIndex === null ? "Add License" : "Edit License"}
                        </h3>

                        <div className="form-group">
                            <label>License Title:</label>
                            <input
                                type="text"
                                value={tempLicense.title}
                                onChange={(e) =>
                                    setTempLicense({ ...tempLicense, title: e.target.value })
                                }
                                className="experience-input"
                            />
                        </div>

                        <div className="form-group">
                            <label>License Number:</label>
                            <input
                                type="text"
                                value={tempLicense.license_number}
                                onChange={(e) =>
                                    setTempLicense({ ...tempLicense, license_number: e.target.value })
                                }
                                className="experience-input"
                            />
                        </div>

                        <div className="form-group">
                            <label>Issue Date:</label>
                            <input
                                type="date"
                                value={tempLicense.issue_date}
                                onChange={(e) =>
                                    setTempLicense({ ...tempLicense, issue_date: e.target.value })
                                }
                                className="experience-input"
                            />
                        </div>

                        {/* Buttons */}
                        <div className="experience-btn-group">
                            <button className="save-btn" onClick={handleSave} disabled={loading}>
                                {loading ? "Saving..." : "Save"}
                            </button>
                            <button className="cancel-btn" onClick={closeModal}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>

    );
};

export default LicenseList;